import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, switchMap, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  const isRefreshRequest = req.url.includes("/auth/refresh/");
  const isLogoutRequest = req.url.includes("/auth/logout/");
  const isLoginRequest =
    req.url.includes("/auth/login") ||
    req.url.includes("/auth/request-otp") ||
    req.url.includes("/auth/verify-otp") ||
    req.url.includes("/auth/resend-otp");

  const shouldSkipAccessToken =
    isRefreshRequest || isLogoutRequest || isLoginRequest;

  const authReq =
    token && !shouldSkipAccessToken
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        })
      : req.clone({
          withCredentials: true,
        });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || shouldSkipAccessToken) {
        return throwError(() => error);
      }

      return authService.refreshToken().pipe(
        switchMap((response) => {
          const newToken = response.access;

          const retryReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
            withCredentials: true,
          });

          return next(retryReq);
        }),
        catchError((refreshError) => {
          authService.logout();
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
